import React, { Component } from 'react';
import { isEmpty } from "lodash";
import Dialog from '../../common/Dialog';
import InputText, { InputSelect } from '../../common/Form';
import { Box, FormControl, InputLabel, Select, OutlinedInput, MenuItem, Checkbox, ListItemText } from '@mui/material';

// const PAGES = {
//     "dashboard": {label:"Dashboard", value:"dashboard"},
//     "users": {label:"Utilisateurs", value:"users"},
//     "spendings": {label:"Dépenses", value:"spendings"},
//     "categories": {label:"Catégories", value:"categories"},
//     "suppliers": {label:"Fournisseurs", value:"suppliers"},
//     "labels": {label:"Labels", value:"labels"},
//     "banks": {label:"Banques", value:"banks"},
//     "payments": {label:"Paiements", value:"payments"},
//     "credits": {label:"Avances", value:"credits"},
//     "extracts": {label:"Extracts", value:"extracts"},
//     "salary": {label:"Salaires", value:"salary"},
// }

export const PAGES = {
    // "dashboard": "Dashboard",
    "users": "Utilisateurs",
    "spendings": "Dépenses",
    "spendings_demand": "Demande de Dépenses (Admin)",
    "categories": "Catégories",
    "suppliers": "Fournisseurs",
    "labels": "Labels",
    "banks": "Banques",
    "payments": "Paiements",
    "credits": "Avances",
    "advances": "Acomptes",
    "projects": "Projets",
    "chantiers": "Chantiers",
    "schedule": "Planning",
    "extracts": "Extracts",
    "salary": "Salaires",
    "incomes": "Recettes",
    "factures": "Factures",
    "budget": "Budget",
    "equipements": "Immos et Matériels",
    "transfers": "Transfert de fonds",
    "demands": "Demandes",
    "society": "Entreprise",
    "teams": "Equipes",

}

export const DEFAULT_ADMIN_PAGES = [
    "dashboard",
    "users",
    "spendings",
    "categories",
    "suppliers",
    "labels",
    "banks",
    "payments",
    "advances",
    "credits",
    "projects",
    "chantiers",
    "factures",
    "incomes",
    "transfers",
    "spendings_demand"
    
]

export const DEFAULT_SUPER_ADMIN_PAGES = [
    "schedule",
    "extracts",
    "equipements",
    "salary",
    "budget",
    "demands",
    "society"
]
export const ROLES = {1:"USER", 2:"ADMIN", 3:"SUPERADMIN", 4:"ADMIN +", 10:"USER +"}
// export const ROLES = (role) => {
//     console.log('====================================');
//     console.log({role});
//     console.log('====================================');
//     switch (role) {
//         case role == 10:
//             return "USER PLUS"
//             break;
//         case role == 4:
//             return "ADMIN PLUS"
//             break;
//         case role > 1:
//             return "ADMIN"
//             break;
//         case role > 2:
//             return "SUPER ADMIN"
//             break;
            
//         case role < 2:
//             return "USER"
//             break;
//     }
// }
   

class AccessTypeForm extends Component {
    state = { 
        access_pages: this.props.access ? this.props.access.access_pages :  [],
        access_name: this.props.access ? this.props.access.access_name :  "",
        errors : {
            acces_pages: "",
            access_name: "",
        }
    }

    handleChange = (e) => {
        const { name, value } = e.target
        this.setState({
            [name]: value
        })
    }
    handleSubmit = async () => {
        if(!isEmpty(this.state.access_pages) && !isEmpty(this.state.access_name) ){
        let data = {
            access_pages:this.state.access_pages.join(", ") ,
            access_name:this.state.access_name ,
        }
            await this.props.newAccess(data)
            if(this.props.STATE.access.error){
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.access.error}`)
            } else { 
                this.props.notif("success", "Enregistré")
                this.props.handleClose()
            }
        } else {
            this.props.notif("error", "Le formulaire contient des erreurs")
        }
    }
    handleSubmitUpdate = async () => {
        if(!isEmpty(this.state.access_pages) && !isEmpty(this.state.access_name) ){
            let data = Object.assign({}, this.props.access)

            data.access_pages = this.state.access_pages.join(", ")
            data.access_name = this.state.access_name
        
            await this.props.updateAccess(data)
            if(this.props.STATE.access.error){
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.access.error}`)
            } else { 
                this.props.notif("success", "Accès mis à jour")
                this.props.handleClose()
            }
        } else {
            this.props.notif("error", "Le formulaire contient des erreurs")
        }
    }
    render() {
        console.log('====================================');
        console.log(this.state.access_pages);
        console.log('====================================');
        return (
            <Dialog
                close={this.props.handleClose}
                submitAction={this.props.update ? this.handleSubmitUpdate : this.handleSubmit}
                appBar
                disabledSubmit={this.props.STATE.access.fetching}
                title="Nouveau type d'accès"
            >
                <InputText 
                    required
                    label="Nom de l'accès"
                    name="access_name"
                    onChange={this.handleChange}
                    value={this.state.access_name}
                    error={this.state.errors.access_name}
                />
                    
                 <Box p={1}>
                    <FormControl variant="outlined" style={{width: "100%"}}>
                        <InputLabel htmlFor="access_pages">Pages</InputLabel>
                        <Select
                            multiple
                            onChange={this.handleChange}
                            value={this.state.access_pages}
                            renderValue={ () => this.state.access_pages.map(page => PAGES[page]).join(", ") }
                            input={<OutlinedInput labelWidth={60} name="access_pages" id="access_pages" />}
                        >
                        { Object.keys(PAGES).map( page  => (
                            <MenuItem key={page} value={page}>
                                <Checkbox checked={this.state.access_pages.indexOf(page) > -1} />
                                <ListItemText primary={PAGES[page]} />
                            </MenuItem>
                        ) ) 
                        }
                        </Select>
                    </FormControl>
                </Box>
            </Dialog>
        );
    }
}

export default AccessTypeForm;